module.exports = __webpack_public_path__ + "media/images/icons/facilities/park-61d6d17f93abdbd1ff904a2a1ac2f3bb.svg";